module.exports = {
  Tab: require('./lib/Tab'),
  TabList: require('./lib/TabList'),
  TabPanel: require('./lib/TabPanel'),
  Wrapper: require('./lib/Wrapper'),
};
